import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "@/lib/api";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getToken()) {
    // Preserve query string (e.g. ?t=<exchange_token>) so Login can consume it.
    return (
      <Navigate
        to={`/login${location.search}`}
        replace
        state={{ from: location }}
      />
    );
  }
  return <>{children}</>;
}
